import { render } from "./predictive-search.vue?vue&type=template&id=ffa2df00"
import script from "./predictive-search.vue?vue&type=script&lang=js"
export * from "./predictive-search.vue?vue&type=script&lang=js"

import "./predictive-search.vue?vue&type=style&index=0&id=ffa2df00&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__